












import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import {
  ITicketFeedProviderMethods,
  ITicketFeedProvider
} from "@/models/providers/ticket";

import { ITicketMessage } from "@/models/tickets";
import { IFile } from "@/models/files";

@Component
export default class TicketMessageFiles extends Vue {
  // Inject

  @Inject({ from: "ticketFeedProviderMethods" })
  public readonly $ticketFeedMethods!: ITicketFeedProviderMethods;

  @Inject({ from: "ticketFeedProviderData" })
  public readonly $ticketFeedData!: () => ITicketFeedProvider;

  // Props

  @Prop({ default: () => [] })
  public files!: IFile[];

  @Prop({ required: true })
  public messageId!: ITicketMessage["id"];

  @Prop({ default: false })
  public isEditable!: boolean;

  // Methods

  public async deleteFile(fileId: IFile["id"]) {
    await this.$ticketFeedMethods.removeFile(this.messageId, fileId);
    this.$buefy.toast.open({
      message: this.$t("_.file_successfully_deleted") as string
    });
    const message = this.$_.find(
      this.$_.get(this.$ticketFeedData(), "messages"),
      ["id", this.messageId]
    );
    if (message) {
      message.files = this.$_.filter(message.files, f => f.id !== fileId);
      message.files.length || message.body !== ""
        ? this.$ticketFeedMethods.updateMessage(message)
        : this.$ticketFeedMethods.removeMessage(message.id);
    }
  }
}
